import { getConfigurationByIdField } from "../helpers/getConfigurationByIdField";
import { types } from "../types/types";

const initialState = {
  configuration: {},
  configurations: [],

  trackingRegisterEnabled: false,
  versionHistoriesRegisterEnabled: false,
  searchInfosRegisterEnabled: false,
  searchResultsRegisterEnabled: false,
  compareResultsRegisterEnabled: false,
  comparisonTechnologyCheckEnabled: false,
  comparisonTechnologyComboEnabled: false,
  comparisonTechnologyButtonEnabled: false,
  comparisonAlternativeCheckEnabled: false,
  comparisonAlternativeComboEnabled: false,
  comparisonAlternativeButtonEnabled: false,
  comparisonExperienceCheckEnabled: false,
  comparisonExperienceComboEnabled: false,
  comparisonExperienceButtonEnabled: false,
  comparisonInnovationCheckEnabled: false,
  comparisonInnovationComboEnabled: false,
  comparisonInnovationButtonEnabled: false,
  comparisonAssistanceCheckEnabled: false,
  comparisonAssistanceComboEnabled: false,
  comparisonAssistanceButtonEnabled: false,
  comparisonFinancialCheckEnabled: false,
  comparisonFinancialComboEnabled: false,
  comparisonFinancialButtonEnabled: false,
  comparisonVisionCheckEnabled: false,
  comparisonVisionComboEnabled: false,
  comparisonVisionButtonEnabled: false,
  comparisonRegulationCheckEnabled: false,
  comparisonRegulationComboEnabled: false,
  comparisonRegulationButtonEnabled: false,
  dashboardBannerSliderEnabled: false,
  dashboardCarouselModulesEnabled: false,
  searchModuleTechnologyEnabled: false,
  searchModuleAlternativeEnabled: false,
  searchModuleExperienceEnabled: false,
  searchModuleInnovationEnabled: false,
  searchModuleAssistanceEnabled: false,
  searchModuleFinancialEnabled: false,
  searchModuleVisionEnabled: false,
  searchModuleRegulationEnabled: false,
  searchModuleInformationTechnologyEnabled: false,
  searchModuleInformationAlternativeEnabled: false,
  searchModuleInformationExperienceEnabled: false,
  searchModuleInformationInnovationEnabled: false,
  searchModuleInformationAssistanceEnabled: false,
  searchModuleInformationFinancialEnabled: false,
  searchModuleInformationVisionEnabled: false,
  searchModuleInformationRegulationEnabled: false,
  serverFrontendDomain: false,
  serverBackendDomain: false,
  serverPathFiles: false,

  // Búsqueda semántica (defaults OFF / compat ON) — developV3Semantic
  semanticSearchEnabled: 'false',
  semanticSearchTechnologyEnabled: 'false',
  semanticSearchAlternativeEnabled: 'false',
  semanticSearchExperienceEnabled: 'false',
  semanticSearchInnovationEnabled: 'false',
  semanticSearchAssistanceEnabled: 'false',
  semanticSearchFinancialEnabled: 'false',
  semanticSearchVisionEnabled: 'false',
  semanticSearchRegulationEnabled: 'false',
  semanticSearchLikeCompatibilityEnabled: 'true',
  semanticSearchModeBadgeEnabled: 'true',
  semanticSearchHelpPopupEnabled: 'true',
  semanticSearchHelpLegendEnabled: 'true',
  gallerySlideSeconds: '8',
  galleryVideoEnabled: 'true',
  galleryPdfEnabled: 'true',
  semanticSearchBridgeEnabled: 'false',
  semanticSearchBridgeMode: 'M3',
  // Fase 2 integration (master/grupos OFF; matriz cruzada; UI OFF)
  semanticSearchIntegrationEnabled: 'false',
  semanticSearchIntegrationPrincipalEnabled: 'false',
  semanticSearchIntegrationSecondaryEnabled: 'false',
  semanticSearchIntegrationDashboardEnabled: 'false',
  semanticSearchIntegrationViewEnabled: 'false',
  semanticSearchIntegrationMode: 'M3',
  semanticSearchIntegrationDashboardNumber: '9',
  semanticSearchIntegrationBridgeTopN: '8',
  // Listas pipe por módulo origen (vacío = sin destinos)
  semanticSearchIntegrationPrincipalTechnology: 'financial|assistance|regulation|vision|experience',
  semanticSearchIntegrationPrincipalAlternative: 'financial|assistance|regulation|vision|experience',
  semanticSearchIntegrationPrincipalInnovation: 'financial|assistance|regulation|vision|experience',
  semanticSearchIntegrationPrincipalExperience: 'financial|assistance|regulation|vision|technology|alternative|innovation',
  semanticSearchIntegrationSecondaryFinancial: 'technology|alternative|experience|innovation',
  semanticSearchIntegrationSecondaryAssistance: 'technology|alternative|experience|innovation',
  semanticSearchIntegrationSecondaryRegulation: 'technology|alternative|experience|innovation',
  semanticSearchIntegrationSecondaryVision: 'technology|alternative|experience|innovation',
  flowCmiTimelineEnabled: 'false',
  visionViewMaxChars: '600',
  visionShortViewMaxChars: '600',
  visionTrayNameMaxChars: '300',
  registerMobilePrefixEnabled: 'true',

  additionalSupportEnabled: 'false',
  additionalSupportTechnologyEnabled: 'false',
  additionalSupportAlternativeEnabled: 'false',
  additionalSupportExperienceEnabled: 'false',
  additionalSupportInnovationEnabled: 'false',
  additionalSupportAssistanceEnabled: 'false',
  additionalSupportFinancialEnabled: 'false',
  additionalSupportVisionEnabled: 'false',
  additionalSupportRegulationEnabled: 'false',
  supportPopupEnabled: 'false',
  supportPopupTechnologyEnabled: 'false',
  supportPopupAlternativeEnabled: 'false',
  supportPopupExperienceEnabled: 'false',
  supportPopupInnovationEnabled: 'false',
  supportPopupAssistanceEnabled: 'false',
  supportPopupFinancialEnabled: 'false',
  supportPopupVisionEnabled: 'false',
  supportPopupRegulationEnabled: 'false',
  supportFormMode: 'hybrid',
  exploreUdemyDashboardEnabled: 'false',
  exploreUdemySearchEnabled: 'false',
  enduserActivityReportsEnabled: 'false',

  flowEngineEnabled: 'false',
  flowEngineTechnologyEnabled: 'false',
  flowEngineAlternativeEnabled: 'false',
  flowEngineExperienceEnabled: 'false',
  flowEngineInnovationEnabled: 'false',
  flowEngineAssistanceEnabled: 'false',
  flowEngineFinancialEnabled: 'false',
  flowEngineVisionEnabled: 'false',
  flowEngineRegulationEnabled: 'false',
  listTableTrayVisualTechnologyEnabled: 'true',
  listTableTrayVisualAlternativeEnabled: 'true',
  listTableTrayVisualExperienceEnabled: 'true',
  listTableTrayVisualInnovationEnabled: 'true',
  listTableTrayVisualAssistanceEnabled: 'true',
  listTableTrayVisualFinancialEnabled: 'true',
  listTableTrayVisualVisionEnabled: 'true',
  listTableTrayVisualRegulationEnabled: 'true',
  flowEngineModalReasonIdEnabled: 'false',
  flowEngineNoteForwardEnabled: 'false',
  flowEngineExpertConsultEnabled: 'false',
  flowEngineExpertConsultTechnologyEnabled: 'false',
  flowEngineExpertConsultAlternativeEnabled: 'false',
  flowEngineExpertConsultExperienceEnabled: 'false',
  flowEngineExpertConsultInnovationEnabled: 'false',
  flowEngineExpertConsultAssistanceEnabled: 'false',
  flowEngineExpertConsultFinancialEnabled: 'false',
  flowEngineExpertConsultVisionEnabled: 'false',
  flowEngineExpertConsultRegulationEnabled: 'false',
  flowChecklistEnabled: 'false',
  flowChecklistLevel: 'subactivity',
  flowChecklistTechnologyEnabled: 'false',
  flowChecklistAlternativeEnabled: 'false',
  flowChecklistExperienceEnabled: 'false',
  flowChecklistInnovationEnabled: 'false',
  flowChecklistAssistanceEnabled: 'false',
  flowChecklistFinancialEnabled: 'false',
  flowChecklistVisionEnabled: 'false',
  flowChecklistRegulationEnabled: 'false',
  flowInboxEditSurfacesTechnology: '',
  flowInboxEditSurfacesAlternative: '',
  flowInboxEditSurfacesExperience: '',
  flowInboxEditSurfacesInnovation: '',
  flowInboxEditSurfacesAssistance: '',
  flowInboxEditSurfacesFinancial: '',
  flowInboxEditSurfacesVision: '',
  flowInboxEditSurfacesRegulation: '',
  flowInboxReassignSurfacesTechnology: '',
  flowInboxReassignSurfacesAlternative: '',
  flowInboxReassignSurfacesExperience: '',
  flowInboxReassignSurfacesInnovation: '',
  flowInboxReassignSurfacesAssistance: '',
  flowInboxReassignSurfacesFinancial: '',
  flowInboxReassignSurfacesVision: '',
  flowInboxReassignSurfacesRegulation: '',
  flowInboxAdminEditEnabled: 'true',
  flowInboxAdminReassignEnabled: 'true',
  flowInboxReassignRoles: 'coordinator|liaison',
  flowPoolOperatorsFeeder: 'feeder|coordinator',
  flowPoolOperatorsPreManager: 'pre-manager|coordinator',
  flowPoolOperatorsManager: 'manager|coordinator',
  flowPoolOperatorsValidator: 'validator|coordinator',
  flowPoolOperatorsEditor: 'editor|coordinator',
  flowPoolOperatorsLiaison: 'liaison|coordinator',
  flowPoolOperatorsCoordinator: 'coordinator',
  flowPoolOperatorsPanel: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolOperatorsList: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersFeeder: 'feeder|pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersPreManager: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersManager: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersValidator: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersEditor: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersLiaison: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersCoordinator: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersPanel: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPoolViewersList: 'pre-manager|manager|validator|editor|liaison|coordinator',
  flowPreManagerEnabled: 'true',
  flowCoordinatorApprovalEnabled: 'true',
  flowLiaisonInboxEnabled: 'true',
  flowHistoryExcelExportEnabled: 'true',
  moduleConfigImportExcelEnabled: 'false',
  recordUpdateExcelTechnology: '',
  recordUpdateExcelAlternative: '',
  recordUpdateExcelExperience: '',
  recordUpdateExcelInnovation: '',
  recordUpdateExcelAssistance: '',
  recordUpdateExcelFinancial: '',
  recordUpdateExcelVision: '',
  recordUpdateExcelRegulation: '',
  massiveDownloadFeeder: 'technology|alternative|experience|innovation|financial|assistance|regulation|vision',
  massiveDownloadPreManage: 'technology|alternative|experience|innovation|financial|assistance|regulation|vision',
  massiveDownloadManager: 'technology|alternative|experience|innovation|financial|assistance|regulation|vision',
  massiveDownloadValidator: 'technology|alternative|experience|innovation|financial|assistance|regulation|vision',
  massiveDownloadEditor: 'technology|alternative|experience|innovation|financial|assistance|regulation|vision',
  allowLoadingRecordFromListEnabled: 'true',
  flowImportMatchToPreEnabled: 'true',
  matchPreManagerToManagerData: 'id',
  flowImportMatchOnlyByCodeEnabled: 'false',
  flowImportPreProblemsEnabled: 'true',
  flowAssignmentRevealTechnology: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealAlternative: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealExperience: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealInnovation: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealAssistance: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealFinancial: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealVision: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',
  flowAssignmentRevealRegulation: 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre',

  documentationWikiEnabled: 'true',
  documentationWikiPdfExportEnabled: 'true',
  documentationWikiPdfExportStrategy: 'backend',
  assignEndUserDocumentationToAdministratorEnabled: 'true',
  documentationWikiEndUserEnabled: 'false',
  uiLanguagesEnabled: 'es|en',
  uiThemeEnabled: 'false',
  uiThemeNightStart: '19',
  uiThemeNightEnd: '7',
  supportInboxExcelExportEnabled: 'true',
  specialistGuidesEnabled: 'true',
  specialistGuidesRoles: 'pre-manager|manager|validator|editor|coordinator|feeder|liaison',
  specialistGuidesTitleEnabled: 'false',

  configurationsP: [],
  configurationsS: [],
  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",

};
export const configurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CONFIGURATION_START_LOADING:

      const trackingRegisterEnabledObj = getConfigurationByIdField('tracking.register.enabled', action.payload);
      const versionHistoriesRegisterEnabledObj = getConfigurationByIdField('versionhistories.register.enabled', action.payload);
      const searchInfosRegisterEnabledObj = getConfigurationByIdField('searchinfos.register.enabled', action.payload);
      const searchResultsRegisterEnabledObj = getConfigurationByIdField('searchresults.register.enabled', action.payload);
      const compareResultsRegisterEnabledObj = getConfigurationByIdField('compareresults.register.enabled', action.payload);
      const comparisonTechnologyCheckEnabledObj = getConfigurationByIdField('comparison.technology.check.enabled', action.payload);
      const comparisonTechnologyComboEnabledObj = getConfigurationByIdField('comparison.technology.combo.enabled', action.payload);
      const comparisonTechnologyButtonEnabledObj = getConfigurationByIdField('comparison.technology.button.enabled', action.payload);
      const comparisonAlternativeCheckEnabledObj = getConfigurationByIdField('comparison.alternative.check.enabled', action.payload);
      const comparisonAlternativeComboEnabledObj = getConfigurationByIdField('comparison.alternative.combo.enabled', action.payload);
      const comparisonAlternativeButtonEnabledObj = getConfigurationByIdField('comparison.alternative.button.enabled', action.payload);
      const comparisonExperienceCheckEnabledObj = getConfigurationByIdField('comparison.experience.check.enabled', action.payload);
      const comparisonExperienceComboEnabledObj = getConfigurationByIdField('comparison.experience.combo.enabled', action.payload);
      const comparisonExperienceButtonEnabledObj = getConfigurationByIdField('comparison.experience.button.enabled', action.payload);
      const comparisonInnovationCheckEnabledObj = getConfigurationByIdField('comparison.innovation.check.enabled', action.payload);
      const comparisonInnovationComboEnabledObj = getConfigurationByIdField('comparison.innovation.combo.enabled', action.payload);
      const comparisonInnovationButtonEnabledObj = getConfigurationByIdField('comparison.innovation.button.enabled', action.payload);
      const comparisonAssistanceCheckEnabledObj = getConfigurationByIdField('comparison.assistance.check.enabled', action.payload);
      const comparisonAssistanceComboEnabledObj = getConfigurationByIdField('comparison.assistance.combo.enabled', action.payload);
      const comparisonAssistanceButtonEnabledObj = getConfigurationByIdField('comparison.assistance.button.enabled', action.payload);
      const comparisonFinancialCheckEnabledObj = getConfigurationByIdField('comparison.financial.check.enabled', action.payload);
      const comparisonFinancialComboEnabledObj = getConfigurationByIdField('comparison.financial.combo.enabled', action.payload);
      const comparisonFinancialButtonEnabledObj = getConfigurationByIdField('comparison.financial.button.enabled', action.payload);
      const comparisonVisionCheckEnabledObj = getConfigurationByIdField('comparison.vision.check.enabled', action.payload);
      const comparisonVisionComboEnabledObj = getConfigurationByIdField('comparison.vision.combo.enabled', action.payload);
      const comparisonVisionButtonEnabledObj = getConfigurationByIdField('comparison.vision.button.enabled', action.payload);
      const comparisonRegulationCheckEnabledObj = getConfigurationByIdField('comparison.regulation.check.enabled', action.payload);
      const comparisonRegulationComboEnabledObj = getConfigurationByIdField('comparison.regulation.combo.enabled', action.payload);
      const comparisonRegulationButtonEnabledObj = getConfigurationByIdField('comparison.regulation.button.enabled', action.payload);
      const dashboardBannerSliderEnabledObj = getConfigurationByIdField('dashboard.banner.slider.enabled', action.payload);
      const dashboardCarouselModulesEnabledObj = getConfigurationByIdField('dashboard.carousel.modules.enabled', action.payload);
      const searchModuleTechnologyEnabledObj = getConfigurationByIdField('search.module.technology.enabled', action.payload);
      const searchModuleAlternativeEnabledObj = getConfigurationByIdField('search.module.alternative.enabled', action.payload);
      const searchModuleExperienceEnabledObj = getConfigurationByIdField('search.module.experience.enabled', action.payload);
      const searchModuleInnovationEnabledObj = getConfigurationByIdField('search.module.innovation.enabled', action.payload);
      const searchModuleAssistanceEnabledObj = getConfigurationByIdField('search.module.assistance.enabled', action.payload);
      const searchModuleFinancialEnabledObj = getConfigurationByIdField('search.module.financial.enabled', action.payload);
      const searchModuleVisionEnabledObj = getConfigurationByIdField('search.module.vision.enabled', action.payload);
      const searchModuleRegulationEnabledObj = getConfigurationByIdField('search.module.regulation.enabled', action.payload);
      const searchModuleInformationTechnologyEnabledObj = getConfigurationByIdField('search.module.information.technology.enabled', action.payload);
      const searchModuleInformationAlternativeEnabledObj = getConfigurationByIdField('search.module.information.alternative.enabled', action.payload);
      const searchModuleInformationExperienceEnabledObj = getConfigurationByIdField('search.module.information.experience.enabled', action.payload);
      const searchModuleInformationInnovationEnabledObj = getConfigurationByIdField('search.module.information.innovation.enabled', action.payload);
      const searchModuleInformationAssistanceEnabledObj = getConfigurationByIdField('search.module.information.assistance.enabled', action.payload);
      const searchModuleInformationFinancialEnabledObj = getConfigurationByIdField('search.module.information.financial.enabled', action.payload);
      const searchModuleInformationVisionEnabledObj = getConfigurationByIdField('search.module.information.vision.enabled', action.payload);
      const searchModuleInformationRegulationEnabledObj = getConfigurationByIdField('search.module.information.regulation.enabled', action.payload);
      const serverFrontendDomainObj = getConfigurationByIdField('server.frontend.domain', action.payload);
      const serverBackendDomainObj = getConfigurationByIdField('server.backend.domain', action.payload);
      const serverPathFilesObj = getConfigurationByIdField('server.path.files', action.payload);
      const flowEngineEnabledObj = getConfigurationByIdField('flow.engine.enabled', action.payload);
      const flowEngineTechnologyEnabledObj = getConfigurationByIdField('flow.engine.technology.enabled', action.payload);
      const flowEngineAlternativeEnabledObj = getConfigurationByIdField('flow.engine.alternative.enabled', action.payload);
      const flowEngineExperienceEnabledObj = getConfigurationByIdField('flow.engine.experience.enabled', action.payload);
      const flowEngineInnovationEnabledObj = getConfigurationByIdField('flow.engine.innovation.enabled', action.payload);
      const flowEngineAssistanceEnabledObj = getConfigurationByIdField('flow.engine.assistance.enabled', action.payload);
      const flowEngineFinancialEnabledObj = getConfigurationByIdField('flow.engine.financial.enabled', action.payload);
      const flowEngineVisionEnabledObj = getConfigurationByIdField('flow.engine.vision.enabled', action.payload);
      const flowEngineRegulationEnabledObj = getConfigurationByIdField('flow.engine.regulation.enabled', action.payload);
      const flowEngineModalReasonIdEnabledObj = getConfigurationByIdField('flow.engine.modal.reason.id.enabled', action.payload);

      const cfgVal = (idField, defaultValue) => {
        const found = getConfigurationByIdField(idField, action.payload);
        return found && found.value !== undefined && found.value !== null ? found.value : defaultValue;
      };

      return {
        ...state,
        configurations: action.payload,

        trackingRegisterEnabled: trackingRegisterEnabledObj.value,
        versionHistoriesRegisterEnabled: versionHistoriesRegisterEnabledObj.value,
        searchInfosRegisterEnabled: searchInfosRegisterEnabledObj.value,
        searchResultsRegisterEnabled: searchResultsRegisterEnabledObj.value,
        compareResultsRegisterEnabled: compareResultsRegisterEnabledObj.value,
        comparisonTechnologyCheckEnabled: comparisonTechnologyCheckEnabledObj.value,
        comparisonTechnologyComboEnabled: comparisonTechnologyComboEnabledObj.value,
        comparisonTechnologyButtonEnabled: comparisonTechnologyButtonEnabledObj.value,
        comparisonAlternativeCheckEnabled: comparisonAlternativeCheckEnabledObj.value,
        comparisonAlternativeComboEnabled: comparisonAlternativeComboEnabledObj.value,
        comparisonAlternativeButtonEnabled: comparisonAlternativeButtonEnabledObj.value,
        comparisonExperienceCheckEnabled: comparisonExperienceCheckEnabledObj.value,
        comparisonExperienceComboEnabled: comparisonExperienceComboEnabledObj.value,
        comparisonExperienceButtonEnabled: comparisonExperienceButtonEnabledObj.value,
        comparisonInnovationCheckEnabled: comparisonInnovationCheckEnabledObj.value,
        comparisonInnovationComboEnabled: comparisonInnovationComboEnabledObj.value,
        comparisonInnovationButtonEnabled: comparisonInnovationButtonEnabledObj.value,
        comparisonAssistanceCheckEnabled: comparisonAssistanceCheckEnabledObj.value,
        comparisonAssistanceComboEnabled: comparisonAssistanceComboEnabledObj.value,
        comparisonAssistanceButtonEnabled: comparisonAssistanceButtonEnabledObj.value,
        comparisonFinancialCheckEnabled: comparisonFinancialCheckEnabledObj.value,
        comparisonFinancialComboEnabled: comparisonFinancialComboEnabledObj.value,
        comparisonFinancialButtonEnabled: comparisonFinancialButtonEnabledObj.value,
        comparisonVisionCheckEnabled: comparisonVisionCheckEnabledObj.value,
        comparisonVisionComboEnabled: comparisonVisionComboEnabledObj.value,
        comparisonVisionButtonEnabled: comparisonVisionButtonEnabledObj.value,
        comparisonRegulationCheckEnabled: comparisonRegulationCheckEnabledObj.value,
        comparisonRegulationComboEnabled: comparisonRegulationComboEnabledObj.value,
        comparisonRegulationButtonEnabled: comparisonRegulationButtonEnabledObj.value,
        dashboardBannerSliderEnabled: dashboardBannerSliderEnabledObj.value,
        dashboardCarouselModulesEnabled: dashboardCarouselModulesEnabledObj.value,
        searchModuleTechnologyEnabled: searchModuleTechnologyEnabledObj.value,
        searchModuleAlternativeEnabled: searchModuleAlternativeEnabledObj.value,
        searchModuleExperienceEnabled: searchModuleExperienceEnabledObj.value,
        searchModuleInnovationEnabled: searchModuleInnovationEnabledObj.value,
        searchModuleAssistanceEnabled: searchModuleAssistanceEnabledObj.value,
        searchModuleFinancialEnabled: searchModuleFinancialEnabledObj.value,
        searchModuleVisionEnabled: searchModuleVisionEnabledObj.value,
        searchModuleRegulationEnabled: searchModuleRegulationEnabledObj.value,
        searchModuleInformationTechnologyEnabled: searchModuleInformationTechnologyEnabledObj.value,
        searchModuleInformationAlternativeEnabled: searchModuleInformationAlternativeEnabledObj.value,
        searchModuleInformationExperienceEnabled: searchModuleInformationExperienceEnabledObj.value,
        searchModuleInformationInnovationEnabled: searchModuleInformationInnovationEnabledObj.value,
        searchModuleInformationAssistanceEnabled: searchModuleInformationAssistanceEnabledObj.value,
        searchModuleInformationFinancialEnabled: searchModuleInformationFinancialEnabledObj.value,
        searchModuleInformationVisionEnabled: searchModuleInformationVisionEnabledObj.value,
        searchModuleInformationRegulationEnabled: searchModuleInformationRegulationEnabledObj.value,
        serverFrontendDomain: serverFrontendDomainObj.value,
        serverBackendDomain: serverBackendDomainObj.value,
        serverPathFiles: serverPathFilesObj?.value ?? 'false',
        flowEngineEnabled: flowEngineEnabledObj?.value ?? 'false',
        flowEngineTechnologyEnabled: flowEngineTechnologyEnabledObj?.value ?? 'false',
        flowEngineAlternativeEnabled: flowEngineAlternativeEnabledObj?.value ?? 'false',
        flowEngineExperienceEnabled: flowEngineExperienceEnabledObj?.value ?? 'false',
        flowEngineInnovationEnabled: flowEngineInnovationEnabledObj?.value ?? 'false',
        flowEngineAssistanceEnabled: flowEngineAssistanceEnabledObj?.value ?? 'false',
        flowEngineFinancialEnabled: flowEngineFinancialEnabledObj?.value ?? 'false',
        flowEngineVisionEnabled: flowEngineVisionEnabledObj?.value ?? 'false',
        flowEngineRegulationEnabled: flowEngineRegulationEnabledObj?.value ?? 'false',
        listTableTrayVisualTechnologyEnabled: cfgVal('list.table.tray-visual.technology.enabled', 'true'),
        listTableTrayVisualAlternativeEnabled: cfgVal('list.table.tray-visual.alternative.enabled', 'true'),
        listTableTrayVisualExperienceEnabled: cfgVal('list.table.tray-visual.experience.enabled', 'true'),
        listTableTrayVisualInnovationEnabled: cfgVal('list.table.tray-visual.innovation.enabled', 'true'),
        listTableTrayVisualAssistanceEnabled: cfgVal('list.table.tray-visual.assistance.enabled', 'true'),
        listTableTrayVisualFinancialEnabled: cfgVal('list.table.tray-visual.financial.enabled', 'true'),
        listTableTrayVisualVisionEnabled: cfgVal('list.table.tray-visual.vision.enabled', 'true'),
        listTableTrayVisualRegulationEnabled: cfgVal('list.table.tray-visual.regulation.enabled', 'true'),
        flowEngineModalReasonIdEnabled: flowEngineModalReasonIdEnabledObj?.value ?? 'false',
        flowEngineNoteForwardEnabled: cfgVal('flow.engine.note.forward.enabled', 'false'),
        flowEngineExpertConsultEnabled: cfgVal('flow.engine.editor.expertConsult.enabled', 'false'),
        flowEngineExpertConsultTechnologyEnabled: cfgVal('flow.engine.editor.expertConsult.technology.enabled', 'false'),
        flowEngineExpertConsultAlternativeEnabled: cfgVal('flow.engine.editor.expertConsult.alternative.enabled', 'false'),
        flowEngineExpertConsultExperienceEnabled: cfgVal('flow.engine.editor.expertConsult.experience.enabled', 'false'),
        flowEngineExpertConsultInnovationEnabled: cfgVal('flow.engine.editor.expertConsult.innovation.enabled', 'false'),
        flowEngineExpertConsultAssistanceEnabled: cfgVal('flow.engine.editor.expertConsult.assistance.enabled', 'false'),
        flowEngineExpertConsultFinancialEnabled: cfgVal('flow.engine.editor.expertConsult.financial.enabled', 'false'),
        flowEngineExpertConsultVisionEnabled: cfgVal('flow.engine.editor.expertConsult.vision.enabled', 'false'),
        flowEngineExpertConsultRegulationEnabled: cfgVal('flow.engine.editor.expertConsult.regulation.enabled', 'false'),
        flowChecklistEnabled: cfgVal('flow.checklist.enabled', 'false'),
        flowChecklistLevel: cfgVal('flow.checklist.level', 'subactivity'),
        flowChecklistTechnologyEnabled: cfgVal('flow.checklist.technology.enabled', 'false'),
        flowChecklistAlternativeEnabled: cfgVal('flow.checklist.alternative.enabled', 'false'),
        flowChecklistExperienceEnabled: cfgVal('flow.checklist.experience.enabled', 'false'),
        flowChecklistInnovationEnabled: cfgVal('flow.checklist.innovation.enabled', 'false'),
        flowChecklistAssistanceEnabled: cfgVal('flow.checklist.assistance.enabled', 'false'),
        flowChecklistFinancialEnabled: cfgVal('flow.checklist.financial.enabled', 'false'),
        flowChecklistVisionEnabled: cfgVal('flow.checklist.vision.enabled', 'false'),
        flowChecklistRegulationEnabled: cfgVal('flow.checklist.regulation.enabled', 'false'),
        flowInboxEditSurfacesTechnology: cfgVal('flow.inbox.technology.edit.surfaces', ''),
        flowInboxEditSurfacesAlternative: cfgVal('flow.inbox.alternative.edit.surfaces', ''),
        flowInboxEditSurfacesExperience: cfgVal('flow.inbox.experience.edit.surfaces', ''),
        flowInboxEditSurfacesInnovation: cfgVal('flow.inbox.innovation.edit.surfaces', ''),
        flowInboxEditSurfacesAssistance: cfgVal('flow.inbox.assistance.edit.surfaces', ''),
        flowInboxEditSurfacesFinancial: cfgVal('flow.inbox.financial.edit.surfaces', ''),
        flowInboxEditSurfacesVision: cfgVal('flow.inbox.vision.edit.surfaces', ''),
        flowInboxEditSurfacesRegulation: cfgVal('flow.inbox.regulation.edit.surfaces', ''),
        flowInboxReassignSurfacesTechnology: cfgVal('flow.inbox.technology.reassign.surfaces', ''),
        flowInboxReassignSurfacesAlternative: cfgVal('flow.inbox.alternative.reassign.surfaces', ''),
        flowInboxReassignSurfacesExperience: cfgVal('flow.inbox.experience.reassign.surfaces', ''),
        flowInboxReassignSurfacesInnovation: cfgVal('flow.inbox.innovation.reassign.surfaces', ''),
        flowInboxReassignSurfacesAssistance: cfgVal('flow.inbox.assistance.reassign.surfaces', ''),
        flowInboxReassignSurfacesFinancial: cfgVal('flow.inbox.financial.reassign.surfaces', ''),
        flowInboxReassignSurfacesVision: cfgVal('flow.inbox.vision.reassign.surfaces', ''),
        flowInboxReassignSurfacesRegulation: cfgVal('flow.inbox.regulation.reassign.surfaces', ''),
        flowInboxAdminEditEnabled: cfgVal('flow.inbox.admin.edit.enabled', 'true'),
        flowInboxAdminReassignEnabled: cfgVal('flow.inbox.admin.reassign.enabled', 'true'),
        flowInboxReassignRoles: cfgVal('flow.inbox.reassign.roles', 'coordinator|liaison'),
        flowPoolOperatorsFeeder: cfgVal('flow.pool.feeder.operators', 'feeder|coordinator'),
        flowPoolOperatorsPreManager: cfgVal('flow.pool.pre-manager.operators', 'pre-manager|coordinator'),
        flowPoolOperatorsManager: cfgVal('flow.pool.manager.operators', 'manager|coordinator'),
        flowPoolOperatorsValidator: cfgVal('flow.pool.validator.operators', 'validator|coordinator'),
        flowPoolOperatorsEditor: cfgVal('flow.pool.editor.operators', 'editor|coordinator'),
        flowPoolOperatorsLiaison: cfgVal('flow.pool.liaison.operators', 'liaison|coordinator'),
        flowPoolOperatorsCoordinator: cfgVal('flow.pool.coordinator.operators', 'coordinator'),
        flowPoolOperatorsPanel: cfgVal('flow.pool.panel.operators', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolOperatorsList: cfgVal('flow.pool.list.operators', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersFeeder: cfgVal('flow.pool.feeder.viewers', 'feeder|pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersPreManager: cfgVal('flow.pool.pre-manager.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersManager: cfgVal('flow.pool.manager.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersValidator: cfgVal('flow.pool.validator.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersEditor: cfgVal('flow.pool.editor.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersLiaison: cfgVal('flow.pool.liaison.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersCoordinator: cfgVal('flow.pool.coordinator.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersPanel: cfgVal('flow.pool.panel.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPoolViewersList: cfgVal('flow.pool.list.viewers', 'pre-manager|manager|validator|editor|liaison|coordinator'),
        flowPreManagerEnabled: cfgVal('flow.pre-manager.enabled', 'true'),
        flowCoordinatorApprovalEnabled: cfgVal('flow.coordinator.approval.enabled', 'true'),
        flowLiaisonInboxEnabled: cfgVal('flow.liaison.inbox.enabled', 'true'),
        flowHistoryExcelExportEnabled: cfgVal('flow.history.excel.export.enabled', 'true'),
        moduleConfigImportExcelEnabled: cfgVal('moduleconfig.import.excel.enabled', 'false'),
        recordUpdateExcelTechnology: cfgVal('record.update.excel.technology', ''),
        recordUpdateExcelAlternative: cfgVal('record.update.excel.alternative', ''),
        recordUpdateExcelExperience: cfgVal('record.update.excel.experience', ''),
        recordUpdateExcelInnovation: cfgVal('record.update.excel.innovation', ''),
        recordUpdateExcelAssistance: cfgVal('record.update.excel.assistance', ''),
        recordUpdateExcelFinancial: cfgVal('record.update.excel.financial', ''),
        recordUpdateExcelVision: cfgVal('record.update.excel.vision', ''),
        recordUpdateExcelRegulation: cfgVal('record.update.excel.regulation', ''),
        massiveDownloadFeeder: cfgVal('allow.massive.download.by.module.feeder.enabled', 'technology|alternative|experience|innovation|financial|assistance|regulation|vision'),
        massiveDownloadPreManage: cfgVal('allow.massive.download.by.module.pre-manage.enabled', 'technology|alternative|experience|innovation|financial|assistance|regulation|vision'),
        massiveDownloadManager: cfgVal('allow.massive.download.by.module.manager.enabled', 'technology|alternative|experience|innovation|financial|assistance|regulation|vision'),
        massiveDownloadValidator: cfgVal('allow.massive.download.by.module.validator.enabled', 'technology|alternative|experience|innovation|financial|assistance|regulation|vision'),
        massiveDownloadEditor: cfgVal('allow.massive.download.by.module.editor.enabled', 'technology|alternative|experience|innovation|financial|assistance|regulation|vision'),
        allowLoadingRecordFromListEnabled: cfgVal('allow.loading.record.from.list.enabled', 'true'),
        flowImportMatchToPreEnabled: cfgVal('flow.import.match.manager.record.to.pre-manager.record.enabled', 'true'),
        matchPreManagerToManagerData: cfgVal('match.pre-manager.to.manager.data', 'id'),
        flowImportMatchOnlyByCodeEnabled: cfgVal('flow.import.match.only.by.code.enabled', 'false'),
        flowImportPreProblemsEnabled: cfgVal('flow.import.pre.problems.enabled', 'true'),
        flowAssignmentRevealTechnology: cfgVal('flow.assignment.reveal.technology', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealAlternative: cfgVal('flow.assignment.reveal.alternative', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealExperience: cfgVal('flow.assignment.reveal.experience', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealInnovation: cfgVal('flow.assignment.reveal.innovation', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealAssistance: cfgVal('flow.assignment.reveal.assistance', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealFinancial: cfgVal('flow.assignment.reveal.financial', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealVision: cfgVal('flow.assignment.reveal.vision', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),
        flowAssignmentRevealRegulation: cfgVal('flow.assignment.reveal.regulation', 'feeder_to_pre|pre_to_manager|manager_to_verificator|verificator_to_editor|editor_to_verificator|verificator_to_manager|manager_to_pre'),

        documentationWikiEnabled: cfgVal('documentation.wiki.enabled', 'true'),
        documentationWikiPdfExportEnabled: cfgVal('documentation.wiki.pdf.export.enabled', 'true'),
        documentationWikiPdfExportStrategy: cfgVal('documentation.wiki.pdf.export.strategy', 'backend'),
        assignEndUserDocumentationToAdministratorEnabled: cfgVal('assign.end-user.documentation.to.administrator.enabled', 'true'),
        documentationWikiEndUserEnabled: cfgVal('documentation.wiki.end-user.enabled', 'false'),
        uiLanguagesEnabled: cfgVal('ui.languages.enabled', 'es|en'),
        uiThemeEnabled: cfgVal('ui.theme.enabled', 'false'),
        uiThemeNightStart: cfgVal('ui.theme.night.start', '19'),
        uiThemeNightEnd: cfgVal('ui.theme.night.end', '7'),

        semanticSearchEnabled: cfgVal('semantic.search.enabled', 'false'),
        semanticSearchTechnologyEnabled: cfgVal('semantic.search.technology.enabled', 'false'),
        semanticSearchAlternativeEnabled: cfgVal('semantic.search.alternative.enabled', 'false'),
        semanticSearchExperienceEnabled: cfgVal('semantic.search.experience.enabled', 'false'),
        semanticSearchInnovationEnabled: cfgVal('semantic.search.innovation.enabled', 'false'),
        semanticSearchAssistanceEnabled: cfgVal('semantic.search.assistance.enabled', 'false'),
        semanticSearchFinancialEnabled: cfgVal('semantic.search.financial.enabled', 'false'),
        semanticSearchVisionEnabled: cfgVal('semantic.search.vision.enabled', 'false'),
        semanticSearchRegulationEnabled: cfgVal('semantic.search.regulation.enabled', 'false'),
        semanticSearchLikeCompatibilityEnabled: cfgVal('semantic.search.like.compatibility.enabled', 'true'),
        semanticSearchModeBadgeEnabled: cfgVal('semantic.search.mode.badge.enabled', 'true'),
        semanticSearchHelpPopupEnabled: cfgVal('semantic.search.help.popup.enabled', 'true'),
        semanticSearchHelpLegendEnabled: cfgVal('semantic.search.help.legend.enabled', 'true'),
        gallerySlideSeconds: cfgVal('gallery.slide.seconds', '8'),
        galleryVideoEnabled: cfgVal('gallery.video.enabled', 'true'),
        galleryPdfEnabled: cfgVal('gallery.pdf.enabled', 'true'),
        semanticSearchBridgeEnabled: cfgVal('semantic.search.bridge.enabled', 'false'),
        semanticSearchBridgeMode: cfgVal('semantic.search.bridge.mode', 'M3'),
        semanticSearchIntegrationEnabled: cfgVal('semantic.search.integration.enabled', 'false'),
        semanticSearchIntegrationPrincipalEnabled: cfgVal('semantic.search.integration.principal.enabled', 'false'),
        semanticSearchIntegrationSecondaryEnabled: cfgVal('semantic.search.integration.secondary.enabled', 'false'),
        semanticSearchIntegrationDashboardEnabled: cfgVal('semantic.search.integration.dashboard.enabled', 'false'),
        semanticSearchIntegrationViewEnabled: cfgVal('semantic.search.integration.view.enabled', 'false'),
        semanticSearchIntegrationMode: cfgVal('semantic.search.integration.mode', 'M3'),
        semanticSearchIntegrationDashboardNumber: cfgVal('semantic.search.integration.dashboard.number', '9'),
        semanticSearchIntegrationBridgeTopN: cfgVal('semantic.search.integration.bridge.top_n', '8'),
        semanticSearchIntegrationFilterBarEnabled: cfgVal(
          'semantic.search.integration.filter.bar.enabled',
          'true'
        ),
        semanticSearchPanelLexicalFromTableEnabled: cfgVal(
          'semantic.search.panel.lexical.from_table.enabled',
          'false'
        ),
        semanticSearchPanelComboFromTableEnabled: cfgVal(
          'semantic.search.panel.combo.from_table.enabled',
          'false'
        ),
        semanticSearchIntegrationM4FromTableEnabled: cfgVal(
          'semantic.search.integration.m4.from_table.enabled',
          'false'
        ),
        semanticSearchIntegrationPrincipalTechnology: cfgVal(
          'semantic.search.integration.principal.technology',
          'financial|assistance|regulation|vision|experience'
        ),
        semanticSearchIntegrationPrincipalAlternative: cfgVal(
          'semantic.search.integration.principal.alternative',
          'financial|assistance|regulation|vision|experience'
        ),
        semanticSearchIntegrationPrincipalInnovation: cfgVal(
          'semantic.search.integration.principal.innovation',
          'financial|assistance|regulation|vision|experience'
        ),
        semanticSearchIntegrationPrincipalExperience: cfgVal(
          'semantic.search.integration.principal.experience',
          'financial|assistance|regulation|vision|technology|alternative|innovation'
        ),
        semanticSearchIntegrationSecondaryFinancial: cfgVal(
          'semantic.search.integration.secondary.financial',
          'technology|alternative|experience|innovation'
        ),
        semanticSearchIntegrationSecondaryAssistance: cfgVal(
          'semantic.search.integration.secondary.assistance',
          'technology|alternative|experience|innovation'
        ),
        semanticSearchIntegrationSecondaryRegulation: cfgVal(
          'semantic.search.integration.secondary.regulation',
          'technology|alternative|experience|innovation'
        ),
        semanticSearchIntegrationSecondaryVision: cfgVal(
          'semantic.search.integration.secondary.vision',
          'technology|alternative|experience|innovation'
        ),
        flowCmiTimelineEnabled: cfgVal('flow.cmi.timeline.enabled', 'false'),
        visionViewMaxChars: cfgVal('vision.view.max.chars', '600'),
        visionShortViewMaxChars: cfgVal('vision_short.view.max.chars', '600'),
        visionTrayNameMaxChars: cfgVal('vision.tray.name.max.chars', '300'),
        registerMobilePrefixEnabled: cfgVal('register.mobile.prefix.enabled', 'true'),

        additionalSupportEnabled: cfgVal('additional.support.enabled', 'false'),
        additionalSupportTechnologyEnabled: cfgVal('additional.support.technology.enabled', 'false'),
        additionalSupportAlternativeEnabled: cfgVal('additional.support.alternative.enabled', 'false'),
        additionalSupportExperienceEnabled: cfgVal('additional.support.experience.enabled', 'false'),
        additionalSupportInnovationEnabled: cfgVal('additional.support.innovation.enabled', 'false'),
        additionalSupportAssistanceEnabled: cfgVal('additional.support.assistance.enabled', 'false'),
        additionalSupportFinancialEnabled: cfgVal('additional.support.financial.enabled', 'false'),
        additionalSupportVisionEnabled: cfgVal('additional.support.vision.enabled', 'false'),
        additionalSupportRegulationEnabled: cfgVal('additional.support.regulation.enabled', 'false'),
        supportPopupEnabled: cfgVal('support.popup.enabled', 'false'),
        supportPopupTechnologyEnabled: cfgVal('support.popup.technology.enabled', 'false'),
        supportPopupAlternativeEnabled: cfgVal('support.popup.alternative.enabled', 'false'),
        supportPopupExperienceEnabled: cfgVal('support.popup.experience.enabled', 'false'),
        supportPopupInnovationEnabled: cfgVal('support.popup.innovation.enabled', 'false'),
        supportPopupAssistanceEnabled: cfgVal('support.popup.assistance.enabled', 'false'),
        supportPopupFinancialEnabled: cfgVal('support.popup.financial.enabled', 'false'),
        supportPopupVisionEnabled: cfgVal('support.popup.vision.enabled', 'false'),
        supportPopupRegulationEnabled: cfgVal('support.popup.regulation.enabled', 'false'),
        supportFormMode: cfgVal('support.form.mode', 'hybrid'),
        exploreUdemyDashboardEnabled: cfgVal('explore.udemy.dashboard.enabled', 'false'),
        exploreUdemySearchEnabled: cfgVal('explore.udemy.search.enabled', 'false'),
        enduserActivityReportsEnabled: cfgVal('enduser.activity.reports.enabled', 'false'),
        supportInboxExcelExportEnabled: cfgVal('support.inbox.excel.export.enabled', 'true'),
        specialistGuidesEnabled: cfgVal('specialist.guides.enabled', 'true'),
        specialistGuidesRoles: cfgVal('specialist.guides.roles', 'pre-manager|manager|validator|editor|coordinator|feeder|liaison'),
        specialistGuidesTitleEnabled: cfgVal('specialist.guides.title.enabled', 'false'),

      };
    case types.CONFIGURATION_START_LOADING_BY_ID_FIELD:
      return {
        ...state,
        configuration: action.payload,
      };

    case types.CONFIGURATION_SELECT:
      return {
        ...state,
        configuration: action.payload,
      };

    case types.CONFIGURATION_UPDATE: {
      const updated = action.payload || {};
      const configurations = (state.configurations || []).map((row) => (
        row.id === updated.id ? { ...row, ...updated } : row
      ));
      const matched = configurations.find((row) => row.id === updated.id) || updated;
      const uiLanguagesEnabled = matched.id_field === 'ui.languages.enabled' && matched.value != null
        ? matched.value
        : state.uiLanguagesEnabled;
      const uiThemeEnabled = matched.id_field === 'ui.theme.enabled' && matched.value != null
        ? matched.value
        : state.uiThemeEnabled;
      const uiThemeNightStart = matched.id_field === 'ui.theme.night.start' && matched.value != null
        ? matched.value
        : state.uiThemeNightStart;
      const uiThemeNightEnd = matched.id_field === 'ui.theme.night.end' && matched.value != null
        ? matched.value
        : state.uiThemeNightEnd;
      const lists = state.configurationsS.length > 0
        ? {
          configurationsS: state.configurationsS.map((usr) => (usr.id === updated.id ? updated : usr)),
          configurationsP: state.configurationsP.map((usr) => (usr.id === updated.id ? updated : usr)),
        }
        : {
          configurationsP: state.configurationsP.map((usr) => (usr.id === updated.id ? updated : usr)),
        };
      return {
        ...state,
        ...lists,
        configurations,
        uiLanguagesEnabled,
        uiThemeEnabled,
        uiThemeNightStart,
        uiThemeNightEnd,
      };
    }

    case types.CONFIGURATION_DELETE:
      if (state.configurationsS.length > 0) {
        return {
          ...state,
          configurationsS: state.configurationsS.filter((usr) => usr.id !== action.payload),
          configurationsP: state.configurationsP.filter((usr) => usr.id !== action.payload),
          configuration: {},
        };
      } else {
        return {
          ...state,
          configurationsP: state.configurationsP.filter((usr) => usr.id !== action.payload),
          configuration: {},
        };
      }

    case types.CONFIGURATION_START_LOADING_PAGINATED:
      return {
        ...state,
        configurationsP: action.payload.configurationsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CONFIGURATION_START_SEARCH:
      return {
        ...state,
        configurationsS: action.payload,
      };

    case types.CONFIGURATION_START_SEARCH_PAGINATED:
      return {
        ...state,
        configurationsS: action.payload.configurationsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CONFIGURATION_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        configurationsS: [],
      };

    case types.CONFIGURATION_CLEAN:
      return {
        ...state,
        configuration: {},
      };

    case types.CONFIGURATION_START_REGISTER:
      return {
        ...state,
        configuration: action.payload,
      };

    case types.CONFIGURATION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
